import { I18n } from 'react-redux-i18n';
import RestClient from '../config/rest-client';
import config from '../config';

const i18n = (code, options) => {
  // fetch(config.apiUrl + '/api/translate/merge', {
  //   headers: {
  //     'Accept': 'application/json',
  //     'Content-Type': 'application/json'
  //   },
  //   method: "POST", body: JSON.stringify({code, lang: localStorage.getItem('languageSite')})
  // })
  return I18n.t(code, options);
}
export default i18n